module.exports = require("/home/vsts/work/1/s/packages/gatsby-theme-husky/gatsby/gatsby-browser.ts");